module.exports = __webpack_public_path__ + "static/Kender_3e-af5bd0da7b8ff4f480b7b7f65a85b751.webp";